import { treesToGeoJson } from '@treetrack/protocol';
import { downloadText, h, todayIso } from '../dom';
import type { ProjectBundle } from '../data';
import { exportCsv, exportFilename } from '../exportRows';
import { t } from '../i18n';
import { toHash } from '../router';
import { button, card } from './shared';

export function exportView(b: ProjectBundle): HTMLElement {
  const today = todayIso();
  const csv = (kind: 'trees' | 'measurements' | 'surveys' | 'interventions', label: string) =>
    button(label, () => downloadText(exportFilename(b.project.code, kind, 'csv', today), exportCsv(kind, b), 'text/csv'), 'btn btn-primary btn-block');
  return h(
    'div',
    { class: 'export' },
    h('a', { class: 'back', href: toHash({ name: 'project', id: b.project.id }) }, `← ${b.project.name}`),
    card(
      t('export.title'),
      h('p', { class: 'hint' }, t('export.hint')),
      h(
        'div',
        { class: 'stack' },
        csv('trees', `${t('export.trees_csv')} (${b.trees.length})`),
        csv('measurements', `${t('export.measurements_csv')} (${b.measurements.length})`),
        csv('surveys', `${t('export.surveys_csv')} (${b.surveys.length})`),
        csv('interventions', `${t('export.interventions_csv')} (${b.interventions.length})`),
        button(
          t('export.trees_geojson'),
          () => downloadText(exportFilename(b.project.code, 'trees', 'geojson', today), JSON.stringify(treesToGeoJson(b.trees, b.latest), null, 1), 'application/geo+json'),
          'btn btn-secondary btn-block',
        ),
      ),
    ),
  );
}
